import React, { useEffect, useState } from "react";
import { Paper, Button, ButtonGroup, Box, Typography } from "@mui/material";
import "../../Styles/strategy.css";
import Portfoliochart from "../charts/PortfoliobarChart";
import StrategyPerformanceTable from "../Tables/StrategyPerformanceTable";
import { useParams } from "react-router";
import { GetStrategy } from "../../redux/Actions/transactionsService";
import { Strategyperformancegraph } from "../../redux/Actions/strategyService";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Loader";
import StrategyAssetTable from "../Tables/StrategyAssetTable";
import { letterSpacing, lineHeight } from "@mui/system";
function Withdraws() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { strategyData, loading } = useSelector((state) => state.transaction);
  const [strategy, setStrategy] = useState([]);
  const [totalPortfolio, setTotalPortfolio] = useState(0);
  const [isInvestorOpen, setIsInvestorOpen] = useState(true);
  const [isAssetOpen, setIsAssetOpen] = useState(false);
  useEffect(() => {
    if (id) {
      dispatch(GetStrategy(id));
      dispatch(Strategyperformancegraph(id));
    }
  }, [id, dispatch]);
  const handleInvestorClick = () => {
    setIsInvestorOpen(true);
    setIsAssetOpen(false);
  };

  const handleAssetClick = () => {
    setIsInvestorOpen(false);
    setIsAssetOpen(true);
  };

  useEffect(() => {
    if (strategyData) {
      const totalPortfolioSum = strategyData.reduce(
        (sum, item) => sum + (item?.totalPortfolio || 0),
        0
      );
      setTotalPortfolio(totalPortfolioSum);
      setStrategy(strategyData);
    } else {
      setStrategy([]);
      setTotalPortfolio(0);
    }
  }, [strategyData]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Box>
          <div className="row" style={{ marginTop: "20px" }}>
            <div className="col-8">
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  "& > :not(style)": {
                    width: 1000,
                    height: 350,
                  },
                }}
              >
                <Paper>
                  <Portfoliochart />
                </Paper>
              </Box>
            </div>
            <div className="col-4">
              <Paper style={{ padding: "20px", height: 350 }}>
                <div className="row" style={{ paddingLeft: "20px" }}>
                  <div>
                    <Typography
                      sx={{
                        color: "#18275A",
                        fontFamily: "SF Pro Display",
                        fontSize: "20px",
                        fontStyle: "normal",
                        fontWeight: "600",
                        lineHeight: "18.664px",
                        mb: 2,
                      }}
                    >
                      Market Value
                    </Typography>
                    <Typography
                      sx={{
                        color: "#149E3B",
                        fontFamily: "SF Pro Display",
                        fontSize: "30px",
                        fontStyle: "normal",
                        fontWeight: "700",
                        lineHeight: "normal",
                        letterSpacing: "-1.5px",
                        mb: 1,
                      }}
                    >
                      $ {totalPortfolio?.toFixed(2)}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#149E3B",
                        fontFamily: "SF Pro Display",
                        fontSize: "25px",
                        fontStyle: "normal",
                        fontWeight: "500",
                        lineHeight: "normal",
                      }}
                    >
                      23% ($935,000)
                    </Typography>
                    <br />
                    <br />
                    <Typography
                      sx={{
                        color: "#18275A",
                        fontFamily: "SF Pro Display",
                        fontSize: "20px",
                        fontStyle: "normal",
                        fontWeight: "600",
                        lineHeight: "18.664px",
                        letterSpacing: "0.2px",
                        mb: 2,
                      }}
                    >
                      Total Capital Invested
                    </Typography>
                    <Typography
                      sx={{
                        color: "#1CA3FE",
                        fontFamily: "SF Pro Display",
                        fontSize: "30px",
                        fontStyle: "normal",
                        fontWeight: "700",
                        lineHeight: "normal",
                        letterSpacing: "-1.5px",
                        mb: 1,
                      }}
                    >
                      $2,000,000
                    </Typography>
                    <br />

                    <Typography
                      sx={{
                        color: "#18275A",
                        fontFamily: "SF Pro Display",
                        fontSize: "20px",
                        fontStyle: "normal",
                        fontWeight: "600",
                        lineHeight: "18.664px",
                        letterSpacing: "0.2px",
                        mb: 2,
                      }}
                    >
                      Revenue Earned{" "}
                    </Typography>

                    <Typography
                      sx={{
                        color: "#18275A",
                        fontFamily: "SF Pro Display",
                        fontSize: "30px",
                        fontStyle: "normal",
                        fontWeight: "700",
                        lineHeight: "normal",
                        letterSpacing: "-1.5px",
                        mb: 1,
                      }}
                    >
                      $50,000
                    </Typography>
                  </div>
                </div>
              </Paper>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-12">
              <ButtonGroup>
                <Button
                  variant={isInvestorOpen ? "contained" : "outlined"}
                  onClick={handleInvestorClick}
                  style={{
                    marginRight: "15px",
                    borderRadius: "5px",
                  }}
                >
                  Investor Performance
                </Button>
                <Button
                  variant={isAssetOpen ? "contained" : "outlined"}
                  onClick={handleAssetClick}
                  style={{
                    marginRight: "15px",
                    marginLeft: "10px",
                    borderRadius: "5px",
                  }}
                >
                  Asset Performance
                </Button>
              </ButtonGroup>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {isInvestorOpen ? (
                <StrategyPerformanceTable strategyObj={strategy} />
              ) : (
                <StrategyAssetTable strategyData={strategy} />
              )}
            </div>
          </div>
        </Box>
      )}
    </>
  );
}

export default Withdraws;
